import React, { Fragment } from "react";

// MUI
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

// MUI Data Grid
import { DataGrid } from "@mui/x-data-grid";

const UserDataGrid = (props) => {
  const { userList, setUserSeq, setUserRecord } = props;

  const columns = [
    {
      field: "eng_name",
      headerName: "English Name",
      width: 250,
    },

    {
      field: "chi_name",
      headerName: "Chinese Name",
      width: 250,
    },

    {
      field: "username",
      headerName: "Username",
      width: 150,
    },

    {
      field: "email",
      headerName: "Email",
      width: 200,
    },

    {
      field: "detail",
      headerName: "Detail Information",
      flex: 1,
      renderCell: (params) => {
        const details = params.value;
        if (!details || details.length === 0) return null;
        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
            {details.map((d, i) => {
              const company = d.company_name || "--";
              const site = d.sas_site_name || "--";
              const section = d.section_name || "--";
              const grade = d.grade_name || "--";
              const position = d.position_name_eng || "--";
              const label = `${company}  |  ${site}`;
              const tip = `Section: ${section}  |  Grade: ${grade}  |  Position: ${position}`;
              return (
                <Tooltip key={i} title={tip} arrow placement="left">
                  <Chip label={label} size="small" variant="outlined" />
                </Tooltip>
              );
            })}
          </Box>
        );
      },
    },
  ];

  const tableRowSelect = (userSeq) => {
    const userSeqSet = new Set(userSeq);
    const selectedRecord = userList.filter((row) => userSeqSet.has(row.id));

    setUserSeq(userSeq);
    setUserRecord(selectedRecord);
  };

  return (
    // console.log("--------------------------------------------------------"),
    // console.log("[UserDataGrid.js]"),
    // console.log("userList : ", userList),
    // console.log("--------------------------------------------------------"),

    <Fragment>
      <Box sx={{ height: 410 }}>
        <DataGrid
          rows={userList}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          density={"compact"}
          //   autoHeight
          checkboxSelection
          disableColumnMenu
          disableColumnFilter
          disableColumnSelector
          disableVirtualization
          disableDensitySelector
          initialState={{
            sorting: {
              sortModel: [{ field: "username", sort: "asc" }],
            },
          }}
          onSelectionModelChange={(params) => tableRowSelect(params)}
          getRowHeight={() => "auto"}
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "break-spaces",
              paddingTop: 1,
              paddingBottom: 1,
            },
          }}
        />
      </Box>
    </Fragment>
  );
};

export default UserDataGrid;
